import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

function BackButton({ routeTo = "" }) {
  // console.log(routeTo);
  const history = useHistory();
  const { t } = useTranslation();

  const handleBack = () => {
    routeTo.length ? history.push(routeTo) : history.goBack();
  };

  return (
    <div style={{ width: "90px", marginLeft: "auto", marginBottom: "10px" }} >
      <span onClick={handleBack} className="wd-back-button" style={{ padding: "5px" }}>
        <i className="fas fa-arrow-left wd-back-icon" /> {t("BACK")}
      </span>
    </div>
  );
}
export default BackButton;
